import { useContext } from "react";
import { ViewSettingsContext } from "./view-settings-context";

export const useViewSettings = () => useContext(ViewSettingsContext);
